import { createSelector } from 'reselect';

import { selectUnderwriting } from './underwriting.selectors';

export const selectRulePreviews = createSelector(
  selectUnderwriting,
  ({ rulePreviews }) => rulePreviews,
);
